import theme from "src/themeNew";

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0',
    margin: '0px',
    '& .MuiDialog-paper': {
      margin: '0px',
      borderRadius: '0',
    },
    '& .MuiPaper-root': {
      height: '100%',
      maxHeight: '100%',
    }
  },
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  modalHeader: {
    height: '72px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    borderBottom: '1px solid #4C4E641F',
    padding: '16px',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '500',
    color: theme.palette.text.primary,
    lineHeight: '28px',
    letter: '-0.25px',
  },
  closeBtn: {
    padding: '0px',
  },
  closeIcon: {
    height: '18px',
    width: '18px',
    color: theme.palette.text.secondary,
  },
  modalContent: {
    flex: 1,
    padding: '20px 24px',
  },
  addNewForm: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  fieldContainer: {
  },
  descr: {
    fontSize: '13px',
    fontWeight: '500',
    color: theme.palette.text.secondary,
    lineHeight: '22px',
    letter: '-0.25px',
  },
  table: {
  },
  tableHeadRow: {
    width: '100%',
    backgroundColor: theme.palette.background.tableHeader,
    padding: '19px 15px 19px 0!important',
    alignItems: 'center',
    height: '56px',
  },
  tableHeadRowDisplay: {
    borderImage: 'linear-gradient(transparent 30%, #4C4E641F 30% 70%, transparent 70%) 0 1 0 0/2px',
    fontSize: '13px',
    color: theme.palette.text.primary,
    lineHeight: '1.2',
    borderBottom: 'none',
    textOverflow: 'ellipsis',
    overflow: 'clip visible',
    whiteSpace: 'nowrap',
    paddingRight: '10px !important',
    textTransform: 'uppercase',
  },
  tableBodyRow: {
    width: '100%',
    backgroundColor: theme.palette.background.white,
    alignItems: 'center',
    borderRadius: '8px 8px 0 0',
    height: '56px',
  },
  tableRowDisplay: {
    fontSize: '13px',
    color: theme.palette.text.primary,
    lineHeight: '1.2',
    borderBottom: '1px solid #4C4E641F',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    padding: '0 16px !important',
  },
  textFieldContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      height: '56px',
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
      lineHeight: '32px !important',
      color: theme.palette.text.primary,
      padding: '4px 8px !important',
      textAlign: 'left' as const,
      backgroundColor: '#FFFFFF',
    }
  },
  percentageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  percentageText: {
    color: theme.palette.text.primary,
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '-0.25px',
  },
  deleteBtn: {
    padding: '6px',
  },
  deleteIcon: {
    width: '18px',
    height: '18px',
  },
  modalFooter: {
    height: '102px',
    width: '100%',
    padding: '32px 20px',
    border: `1px solid ${theme.palette.border.footer}`,
    boxShadow: `0px 2px 6px 0px ${theme.palette.boxShadow.primary}`
  },
  errorContainer: {
    padding: '14px 16px',
    margin: '0 16px',
    color: theme.palette.text.primary,
    boxShadow: `0px 2px 6px 0px ${theme.palette.boxShadow.primary}`,
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center'
  },
  errorIcon: {
    color: theme.palette.error.main,
    mr: 1,
  },
  loadDistributeContainerOuter: {
    p: 2,
  },
  loadDistributeContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  equalDistributionContainer: {
    display: 'flex',
    alignItems: 'center'
  },

}

export default styles;
